{
  "paymentMethod": {
    "BANK_CARD": "บัตรธนาคาร",
    "ALIPAY": "Alipay",
    "WECHAT": "WeChat"
  },
  "flatFee": "ต่อรายการ {{amount}}",
  "vipConditionsTitle": "เงื่อนไขธุรกรรมด่วน VIP {{level}}",
  "noVipPaymentMethods": "ระดับ VIP ปัจจุบันไม่มีวิธีชำระเงินสำหรับธุรกรรมด่วน",
  "fee": "ค่าธรรมเนียม {{value}}",
  "availableRange": "ช่วงที่ใช้ได้ {{value}}",
  "checkout": "ชำระเงินด้วย {{method}}",
  "close": "ปิด",
  "checkoutLoading": "กำลังโหลดหน้าชำระเงิน…",
  "checkoutLoadFailed": "ไม่สามารถโหลดหน้าชำระเงินได้ชั่วคราว โปรดลองอีกครั้ง",
  "retry": "ลองอีกครั้ง",
  "checkoutHint": "โปรดชำระเงินด้วย {{method}} ในหน้านี้ ระบบจะยืนยันยอดให้อัตโนมัติเมื่อเสร็จสิ้น",
  "openCheckout": "เปิดหน้าชำระเงิน",
  "externalCheckoutHint": "เปิดหน้าต่างใหม่เพื่อชำระเงินด้วย {{method}} ระบบจะยืนยันยอดให้อัตโนมัติเมื่อเสร็จสิ้น คุณสามารถกลับมาที่นี่เพื่อเปิดหน้าชำระเงินอีกครั้งหรือเลือกวิธีอื่น",
  "externalCheckoutUnavailableHint": "หากเปิดหรือโหลดหน้าชำระเงินไม่ได้ ให้กลับมาที่นี่เพื่อเลือกวิธีชำระเงินอื่น",
  "chooseOtherMethod": "เลือกวิธีชำระเงินอื่น",
  "chooseOtherMethodHint": "เลือกวิธีอื่นเฉพาะเมื่อยังไม่ได้ชำระเงิน คำสั่งซื้อนี้จะคงอยู่จนกว่าจะได้รับเงินหรือหมดอายุ"
}
